/**
 * Legacy iOS audio-session "Now Playing" keep-alive bridge.
 *
 * Disabled as of the Live Activity migration: the BackgroundGeolocation plugin
 * already keeps the app alive via Core Location's native background mode, and
 * the Live Activity provides the lock-screen presence. Activating an audio
 * session here (a) showed a misleading "Straiv Fitness" Now Playing tile on
 * the lock screen, (b) interrupted Spotify/Apple Music, and (c) could wedge
 * the audio graph between runs (causing the countdown TTS to hang on a
 * second consecutive run).
 *
 * All exports are kept as no-ops so call-sites in RunningStart/RunningActive
 * don't need changes.
 */

export const setStraivNowPlaying = (_active: boolean, _title?: string) => {
  // no-op
};

export const prepareAudioForRun = () => {
  // no-op
};

export const resumeMusicAfterRunStart = () => {
  // no-op
};

export const prepareBackgroundKeepAlive = () => {
  // no-op
};
